export default __webpack_public_path__ + "src/assets/images/landing/img_bg_2_12-9ryF.jpg";